<template>
  <b-card>
    <b-card-header>
      <i class="icon-menu mr-1"></i>Group Detail
    </b-card-header>
    <Group :id="$route.params.id"/>
    <h3>Members</h3>
    <Users :groupTo="$route.params.id"/>
    <template slot="footer">
      <b-button @click="goBack">Back</b-button>
    </template>
  </b-card>
</template>

<script>
import Group from '../groups/Group'
import Users from '../users/Users'

export default {
  name: 'GroupDetail',
  components: {
      Group,
      Users,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
